import React from 'react';
import '../styles/Eventscalendar.css';

const EventsCalendar = ({ events = [] }) => {
  // Sort events by date
  const sortedEvents = [...events].sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return dateA - dateB;
  });

  // Filter out past events (optional - you can remove this if you want to show all events)
  const upcomingEvents = sortedEvents.filter(event => {
    const eventDate = new Date(event.date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return eventDate >= today;
  });

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  const formatTime = (timeString) => {
    if (!timeString) return '';
    // Handle both HH:MM and HH:MM:SS formats
    const [hours, minutes] = timeString.split(':');
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${minutes} ${ampm}`;
  };

  if (upcomingEvents.length === 0) {
    return (
      <div className="events-calendar">
        <h2>Events</h2>
        <p className="no-events">No events scheduled at this time. Check back soon!</p>
      </div>
    );
  }

  return (
    <div className="events-calendar">
      <h2>Events</h2>
      <div className="events-list">
        {upcomingEvents.map((event, index) => (
          <div key={index} className="event-card">
            <div className="event-date">
              <div className="event-day">
                {new Date(event.date).getDate()}
              </div>
              <div className="event-month">
                {new Date(event.date).toLocaleDateString('en-US', { month: 'short' })}
              </div>
            </div>
            <div className="event-details">
              <h3 className="event-title">{event.title}</h3>
              <p className="event-datetime">
                {formatDate(event.date)}
                {event.time && ` at ${formatTime(event.time)}`}
              </p>
              {event.location && (
                <p className="event-location">📍 {event.location}</p>
              )}
              {event.description && (
                <p className="event-description">{event.description}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventsCalendar;